export default "__VITE_ASSET__a425b39c__"